import { featureHighlights } from "@/mocks/siteConfig";

export default function FeaturesSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-white">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            为什么选择 mogu？
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            mogu 提供全方位的一站式解决方案，从数据分析到团队协作，助力企业和个人实现数字化转型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureHighlights.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-8 rounded-2xl bg-background-100/80 border border-transparent hover:border-foreground-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-foreground-950 text-white mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}